import api from '../index';

export const GetAllSubadmin = (params) => api.get(`admin/get-all-subadmin?${params}`);
export const AddSubadmin = (data) => api.post('admin/add-update-subadmin', data);
export const GetSubadminsAndPermissionApi = (userId) => api.get(`rolepermission/modules-permission-by-user/${userId}`);
export const AssignPermissionToSubAdminApi = (data) => api.post('rolepermission/assign-permissionstorole', data);
export const UserStatusChangeApi = (data) => api.put('usermaster/toogle-user-activation', data);
export const DeleteSubadminApi = (userId) => api.delete(`admin/delete-sub-admin/${userId}`);
